import { useContext, useEffect, useState } from "react"
import SiteContext from "../../contexts/SiteContext"

import { makeStyles, useTheme } from "@material-ui/core/styles"

import {
    Bairros,
    CadastrarEnderecoCliente,
    CalculaEnderecoUsuarioSemUsuario,
    CidadesAtendidasPorAplicativo,
    Post_ListarEstabelecimentosPorEndereco,
    RegistrarLogErro,
} from "../../services/functions"

import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"

import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import IconButton from "@material-ui/core/IconButton"
import MenuItem from "@material-ui/core/MenuItem"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"

import useMediaQuery from "@material-ui/core/useMediaQuery"
import useAlert from "../../contexts/AlertContext"
import useEndereco from "../../contexts/EnderecoContext"
import { useTextos } from "../../contexts/TextosContext"

const useStyles = makeStyles(theme => ({
    actions: {
        paddingInline: "1.5rem",
        alignItems: "stretch",
        gap: "1rem",
        "& > button": {
            flex: 1,
            margin: "0 !important",
            "&:nth-child(2)": { backgroundColor: "#28a745", color: "white" },
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column-reverse",
            gap: "0.5rem",
        },
    },
}))

export default function DialogEnderecos({ DialogConfirmacaoinformacoes = () => {} }) {
    const {
        aplicativoDados,
        estabelecimentoAtual,
        carrinho,

        setLoading,

        continuarSemCadastro,

        usuarioLogado,
        setUsuarioLogado,
    } = useContext(SiteContext)

    const textos = useTextos()
    const alertStart = useAlert()
    const classes = useStyles()

    const {
        novoEndereco,

        selecionarEndereco,

        abrirNovoEndereco,

        iniciarCadastroEndereco,
        fecharCadastroEndereco,

        finalizarCadastroEndereco,
        selecionarRetiradaNoLocal,
    } = useEndereco()

    const usuarioPedidoMesa = JSON.parse(localStorage.getItem("usuarioPedidoMesaCF"))

    const [cidades, setCidades] = useState([])
    const [bairrosAtendidos, setBairrosAtendidos] = useState([])
    const [bloquearCampos, setBloquearCampos] = useState({
        cidade: false,
        rua: false,
    })

    const [endereco, setEndereco] = useState({
        idCliente: usuarioLogado?.cliente.id,
        idEstabelecimento: estabelecimentoAtual?.id,
        cep: "",
        uf: "",
        cidade: "",
        bairro: "",
        logradouro: "",
        numero: "",
        complemento: "",
        referencia: "",
        appNome: aplicativoDados.appNome,
        latitude: 0,
        longitude: 0,
        token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
    })

    useEffect(() => {
        if (abrirNovoEndereco) {
            possiveisCidades(novoEndereco?.localidade)

            if (novoEndereco)
                setEndereco({
                    idCliente: usuarioLogado?.cliente.id,
                    idEstabelecimento: estabelecimentoAtual?.id,
                    cep: novoEndereco.cep ?? "",
                    uf: novoEndereco.uf ?? "",
                    cidade: novoEndereco.localidade ?? "",
                    bairro: novoEndereco.bairro ?? "",
                    bairroEspecifico: novoEndereco.bairroEspecifico,
                    logradouro: novoEndereco.logradouro,
                    numero: "",
                    complemento: "",
                    referencia: "",
                    appNome: aplicativoDados.appNome,
                    latitude: novoEndereco.latitude ?? 0,
                    longitude: novoEndereco.longitude ?? 0,
                    token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                })

            if (novoEndereco?.bairros?.length > 0) setBairrosAtendidos(novoEndereco.bairros)

            setBloquearCampos(prev => ({
                ...prev,
                cidade: !!novoEndereco?.localidade,
                logradouro: !!novoEndereco?.logradouro,
                bairro: !!novoEndereco?.bairro && aplicativoDados.tipoEntregaBairro === 0,
            }))
        }
    }, [novoEndereco, abrirNovoEndereco])

    useEffect(() => {
        if (cidades.length === 1) {
            possiveisBairros(cidades[0].nome)
        } else if (endereco.cidade && !!novoEndereco.bairro) {
            possiveisBairros(endereco.cidade)
        }
        if (cidades.length === 1) {
            setEndereco(prev => ({
                ...prev,
                cidade: cidades[0].nome,
                uf: cidades[0].estado.sigla,
            }))
        }
    }, [cidades])

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const handleClose = () => {
        setEndereco({
            idCliente: usuarioLogado?.cliente.id,
            idEstabelecimento: estabelecimentoAtual?.id,
            cep: "",
            uf: "",
            cidade: "",
            bairro: "",
            logradouro: "",
            numero: "",
            complemento: "",
            referencia: "",
            appNome: aplicativoDados.appNome,
            latitude: 0,
            longitude: 0,
            token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
        })

        fecharCadastroEndereco()
    }

    const possiveisCidades = async cidadeSelecionada => {
        setLoading(true)
        try {
            let retornoCidades = []
            await CidadesAtendidasPorAplicativo(
                { appNome: aplicativoDados.appNome },
                aplicativoDados
            ).then(retorno => {
                if (retorno?.retornoErro) {
                    alertStart(retorno?.mensagem, "error")
                    setLoading(false)
                    return
                }
                setLoading(false)
                setCidades(retorno)
                if (cidadeSelecionada) {
                    if (retorno.filter(cidade => cidade.nome === cidadeSelecionada).length === 0) {
                        alertStart(textos.alertas.naoAtendeCidade, "error")
                        fecharCadastroEndereco()
                        iniciarCadastroEndereco()
                    }
                    possiveisBairros(cidadeSelecionada, retorno)
                }
                retornoCidades = retorno
            })
            return retornoCidades
        } catch (error) {
            RegistrarLogErro(error, "CidadesAtendidasPorAplicativo", aplicativoDados)
            alertStart("Erro não identificado ao buscar CidadesAtendidasPorAplicativo", "error")
            setLoading(false)
        }
    }

    const possiveisBairros = async (cidadeSelecionada, listaCidades = cidades) => {
        setLoading(true)
        try {
            const cidade = listaCidades?.filter(cidade => cidade.nome == cidadeSelecionada)[0]
            if (!listaCidades.length && !cidade) {
                setLoading(false)
                return
            }
            if (!cidade) {
                alertStart(textos.alertas.naoAtendeCidade, "error")
                handleClose()
                setLoading(false)
                return
            }
            const retorno = await Bairros(cidade, aplicativoDados)

            if (retorno.retornoErro) {
                alertStart(retorno.mensagem, "error")
                setLoading(false)
                setBairrosAtendidos([])
                return
            }

            if (endereco.bairro && !retorno.find(b => b.nome === endereco.bairro))
                retorno.push({
                    mensagem: null,
                    codErro: null,
                    token: null,
                    appNome: null,
                    pagina: null,
                    versaoApp: null,
                    id: null,
                    versao: 0,
                    nome: endereco.bairro,
                    nomeAlternativo: null,
                    cidade: cidade,
                    selecionado: false,
                    qtdClientes: null,
                })

            setBairrosAtendidos(retorno)
            setLoading(false)
        } catch (error) {
            setBairrosAtendidos([])
            RegistrarLogErro(error, "CidadesAtendidasPorAplicativo", cidadeSelecionada)
            alertStart("Erro não identificado ao buscar CidadesAtendidasPorAplicativo", "error")
        }
        setLoading(false)
    }

    const verificarDadosCadastroEndereco = () => {
        if (!cidades?.length || !endereco.cidade) {
            alertStart(textos.alertas.preencherCidade, "warning")
            document.getElementById("cadastroCidade")?.focus()
            return false
        }

        if (!endereco.bairro) {
            alertStart(textos.alertas.preencherBairro, "warning")
            document.getElementById("cadastroBairro")?.focus()
            return false
        }

        if (!endereco.logradouro) {
            alertStart(textos.alertas.preencherRua, "warning")
            document.getElementById("cadastroLogradouro")?.focus()
            return false
        }

        if (!endereco.numero && !endereco.logradouro.includes("qd")) {
            alertStart(
                aplicativoDados.tipoEndereco
                    ? textos.alertas.preencherQuadraELote
                    : textos.alertas.preencherNumero,
                "warning"
            )
            document.getElementById("cadastroNumero")?.focus()
            return false
        }

        return true
    }

    const cadastrarEndereco = async () => {
        if (aplicativoDados.tipoEntregaBairro === 1) endereco.bairroEspecifico = 1
        else endereco.bairroEspecifico = 0

        const semCadastro = !usuarioLogado?.logado && !usuarioPedidoMesa?.logado

        const enderecoComTaxaMinima =
            semCadastro && estabelecimentoAtual?.id
                ? await CalculaEnderecoUsuarioSemUsuario(
                      { estabelecimentoAtual, endereco },
                      aplicativoDados
                  )
                : endereco

        try {
            if (semCadastro) {
                setLoading(true)

                enderecoComTaxaMinima.token = process.env.REACT_APP_CLIENTEFIEL_TOKEN
                enderecoComTaxaMinima.appNome = aplicativoDados.appNome

                const retorno = await Post_ListarEstabelecimentosPorEndereco(
                    enderecoComTaxaMinima,
                    aplicativoDados
                )
                if (retorno.retornoErro) {
                    alertStart(retorno.mensagem, "error")
                    setLoading(false)
                    return
                } else {
                    localStorage.setItem("estabelecimentosTaxasEnderecos", JSON.stringify(retorno))

                    const estabelecimentosQueEntregam = retorno.filter(
                        estabelecimento => estabelecimento?.taxaEntrega != -1
                    )
                    const estabelecimentoAtualComTaxa = estabelecimentosQueEntregam.filter(
                        estabelecimento => estabelecimento.id === estabelecimentoAtual?.id
                    )
                    if (estabelecimentoAtualComTaxa.length) {
                        enderecoComTaxaMinima.taxaEntrega =
                            estabelecimentoAtualComTaxa[0]?.taxaEntrega
                        // alertStart(`${formatarParaDinheiro(estabelecimentoAtualComTaxa[0].taxaEntrega)} é a taxa de entrega para o endereço cadastrado.`, "success")
                        if (estabelecimentoAtualComTaxa[0].mensagem)
                            alertStart(estabelecimentoAtualComTaxa[0].mensagem, "success")
                    } else {
                        if (estabelecimentoAtual?.id) {
                            enderecoComTaxaMinima.taxaEntrega = -1
                            if (estabelecimentosQueEntregam.length) {
                                alertStart(
                                    `${textos.alertas.naoAtendeEndereco}. ${textos.alertas.outroEnderecoAtente}.`,
                                    "error"
                                )
                            } else {
                                alertStart(`${textos.alertas.naoAtendeEndereco}.`, "error")
                            }
                        }
                    }
                }
            } else {
                endereco.idCliente = usuarioLogado?.cliente.id
                const response = await CadastrarEnderecoCliente(endereco, aplicativoDados)
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                    setLoading(false)
                    return
                } else {
                    if (usuarioLogado.cliente.enderecos === null) {
                        usuarioLogado.cliente.enderecos = []
                    }

                    let newEnderecos = [...usuarioLogado.cliente.enderecos]

                    endereco.token = process.env.REACT_APP_CLIENTEFIEL_TOKEN
                    endereco.appNome = aplicativoDados.appNome

                    const retorno = await Post_ListarEstabelecimentosPorEndereco(
                        endereco,
                        aplicativoDados
                    )

                    // TODO: *IMPORTANTE* checar se EnderecoContext precisa (ao cadastrar endereço na tela de estabelecimento)
                    // localStorage.setItem("estabelecimentosTaxasEnderecos", JSON.stringify(retorno))

                    if (estabelecimentoAtual) {
                        const estabelecimento = retorno.find(e => e.id === estabelecimentoAtual.id)

                        if (estabelecimento?.taxaEntrega === -1) {
                            if (retorno.find(e => e.taxaEntrega >= 0)) {
                                alertStart(
                                    `${textos.alertas.naoAtendeEndereco}. ${textos.alertas.outroEnderecoAtente}.`,
                                    "error"
                                )

                                newEnderecos.push(endereco)
                                usuarioLogado.cliente.enderecos = newEnderecos
                                setUsuarioLogado(usuarioLogado)
                                selecionarEndereco(response)
                                finalizarCadastroEndereco()
                            } else {
                                alertStart(textos.alertas.naoAtendeEndereco, "error")
                            }

                            return
                        }

                        if (estabelecimento?.taxaEntrega >= 0) {
                            endereco.taxaEntrega = estabelecimento.taxaEntrega
                        }
                    }

                    newEnderecos.push(endereco)
                    usuarioLogado.cliente.enderecos = newEnderecos
                    setUsuarioLogado(usuarioLogado)
                    selecionarEndereco(response)
                    alertStart(response.mensagem, "success")
                }
            }

            selecionarEndereco(enderecoComTaxaMinima)
            finalizarCadastroEndereco()
            handleClose()
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "cadastroEnderecoCardapio", { endereco, aplicativoDados })
            alertStart("Procure os desenvolvedores " + error.message, "error")
            setLoading(false)
            fecharCadastroEndereco()
        }
        handleClose()
        finalizarCadastroEndereco()
        if (carrinho.pedido?.itens?.length && enderecoComTaxaMinima.taxaEntrega !== -1) {
            DialogConfirmacaoinformacoes(true)
        }
    }

    const handleCadastro = () => {
        const isDadosValidos = verificarDadosCadastroEndereco()
        if (!isDadosValidos) return

        cadastrarEndereco()
    }

    return (
        <Dialog
            open={abrirNovoEndereco}
            aria-labelledby="novoEndereco-title"
            fullWidth={true}
            maxWidth={"md"}
            onClose={handleClose}
        >
            {!fullScreen ? <img src={aplicativoDados.urlLogo} className="imgModal" /> : null}
            <DialogTitle id="novoEndereco-title">
                <IconButton className="setaVoltarModal" onClick={handleClose}>
                    <ArrowForwardIosIcon />
                </IconButton>
                {textos.adicionarEndereco}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="cadastroCidade"
                            name="cidade"
                            label={textos.cidade}
                            select
                            variant="outlined"
                            value={endereco.cidade ?? ""}
                            disabled={bloquearCampos.cidade}
                            onChange={e => {
                                possiveisBairros(e.target.value)
                            }}
                        >
                            {cidades?.map(cidade => (
                                <MenuItem
                                    key={cidade.id}
                                    value={cidade.nome}
                                    onClick={e => {
                                        setEndereco({
                                            ...endereco,
                                            ["uf"]: cidade.estado.sigla,
                                            ["cidade"]: cidade.nome,
                                            ["bairro"]: "",
                                        })
                                    }}
                                >
                                    {cidade.nomeCompleto}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="cadastroBairro"
                            name="bairro"
                            label={textos.bairro}
                            select
                            variant="outlined"
                            value={endereco.bairro ?? ""}
                            disabled={bloquearCampos.bairro}
                            onChange={e => {
                                setEndereco({ ...endereco, ["bairro"]: e.target.value })
                            }}
                        >
                            {bairrosAtendidos.map(bairro => (
                                <MenuItem key={bairro.id} value={bairro.nome}>
                                    {bairro.nome}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="cadastroLogradouro"
                            variant="outlined"
                            name="rua"
                            label={textos.rua}
                            value={endereco.logradouro ?? ""}
                            disabled={bloquearCampos.logradouro}
                            onChange={e => {
                                setEndereco({ ...endereco, ["logradouro"]: e.target.value })
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="cadastroNumero"
                            variant="outlined"
                            name={aplicativoDados.tipoEndereco ? "quadraLote" : "numero"}
                            label={aplicativoDados.tipoEndereco ? "Quadra e Lote" : textos.numero}
                            value={endereco.numero ?? ""}
                            onChange={e => {
                                setEndereco({ ...endereco, ["numero"]: e.target.value })
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            fullWidth
                            id="cadastroComplemento"
                            variant="outlined"
                            name="complemento"
                            label={textos.complemento}
                            value={endereco.complemento ?? ""}
                            onChange={e => {
                                setEndereco({ ...endereco, ["complemento"]: e.target.value })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            id="cadastroReferencia"
                            variant="outlined"
                            name="referencia"
                            label={textos.referencia}
                            value={endereco.referencia ?? ""}
                            onChange={e => {
                                setEndereco({ ...endereco, ["referencia"]: e.target.value })
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button variant="contained" onClick={selecionarRetiradaNoLocal}>
                    {textos.retirarNoLocal}
                </Button>
                <Button variant="contained" onClick={handleCadastro}>
                    {textos.adicionar}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
